import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Mail, Lock, AlertCircle } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  // HU19-04: recuperación de contraseña — sin SMTP, genera una solicitud visible al admin
  const [vistaRecuperar, setVistaRecuperar] = useState(false);
  const [emailRecuperar, setEmailRecuperar] = useState('');
  const [mensajeRecuperar, setMensajeRecuperar] = useState('');
  const [enviandoRecuperar, setEnviandoRecuperar] = useState(false);

  const solicitarRecuperacion = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!emailRecuperar.trim()) return;
    setEnviandoRecuperar(true); setMensajeRecuperar('');
    try {
      const { data } = await authService.solicitarRecuperacion(emailRecuperar.trim());
      setMensajeRecuperar(data.mensaje || 'Solicitud registrada. Un administrador la revisará pronto.');
    } catch {
      setMensajeRecuperar('No se pudo registrar la solicitud. Intenta de nuevo.');
    } finally { setEnviandoRecuperar(false); }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) { setError('Ingresa email y contraseña'); return; }
    setCargando(true); setError('');
    try {
      const { data } = await authService.login(email, password);
      login(data.token, data.usuario);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Credenciales incorrectas');
    } finally { setCargando(false); }
  };

  return (
    <div style={{
      minHeight: 'var(--vh100, 100vh)', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--strong)', padding: '0 16px', position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', top: -120, right: -120, width: 360, height: 360, borderRadius: '50%', background: 'rgba(220,38,38,.12)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -120, left: -120, width: 360, height: 360, borderRadius: '50%', background: 'rgba(220,38,38,.06)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 48, height: 48, borderRadius: 14, background: 'var(--brand)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 22, fontWeight: 700, color: 'var(--on-brand)' }}>C</div>
          <h1 style={{ color: '#fff', fontSize: 22, fontWeight: 700, letterSpacing: '-.02em', margin: 0 }}>CHARGOY</h1>
          <p style={{ color: 'rgba(255,255,255,.4)', fontSize: 13, marginTop: 4, marginBottom: 0 }}>Panel de administración</p>
        </div>

        <div style={{ background: 'var(--surface)', borderRadius: 16, boxShadow: '0 24px 60px rgba(0,0,0,.4)', padding: 32 }}>
          {error && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--danger-bg)', color: 'var(--brand-texto)', fontSize: 13, padding: '10px 14px', borderRadius: 9, marginBottom: 20, border: '1px solid var(--danger-line)' }}>
              <AlertCircle size={15} style={{ flexShrink: 0 }} />{error}
            </div>
          )}
          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {[
              { label: 'Usuario', type: 'text', value: email, onChange: setEmail, placeholder: 'nombre o correo', icon: Mail, auto: 'username' },
              { label: 'Contraseña', type: 'password', value: password, onChange: setPassword, placeholder: '••••••••', icon: Lock, auto: 'current-password' },
            ].map(({ label, type, value, onChange, placeholder, icon: Icon, auto }) => (
              <div key={label}>
                <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.06em', display: 'block', marginBottom: 6 }}>{label}</label>
                <div style={{ position: 'relative' }}>
                  <Icon size={15} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--faint)' }} />
                  <input
                    type={type} value={value} onChange={e => onChange(e.target.value)}
                    placeholder={placeholder} autoComplete={auto}
                    style={{ width: '100%', height: 42, border: '1px solid var(--line-strong)', borderRadius: 9, paddingLeft: 38, paddingRight: 14, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
                    onFocus={e => (e.target.style.borderColor = 'var(--brand-texto)')}
                    onBlur={e => (e.target.style.borderColor = 'var(--line-strong)')}
                  />
                </div>
              </div>
            ))}
            <button
              type="submit" disabled={cargando}
              style={{ marginTop: 4, height: 44, borderRadius: 9, border: 'none', background: 'var(--brand)', color: 'var(--on-brand)', fontSize: 14, fontWeight: 600, cursor: cargando ? 'not-allowed' : 'pointer', opacity: cargando ? .7 : 1 }}
            >
              {cargando ? 'Verificando…' : 'Iniciar sesión'}
            </button>
          </form>
          <button onClick={() => { setVistaRecuperar(true); setEmailRecuperar(''); setMensajeRecuperar(''); }}
            style={{ marginTop: 14, width: '100%', textAlign: 'center', background: 'none', border: 'none', color: 'var(--muted)', fontSize: 13, cursor: 'pointer' }}>
            ¿Olvidaste tu contraseña?
          </button>
        </div>
      </div>

      {vistaRecuperar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}
          onClick={() => setVistaRecuperar(false)}>
          <div style={{ background: 'var(--surface)', borderRadius: 16, padding: 28, width: '90%', maxWidth: 380 }} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontSize: 17, fontWeight: 700, margin: '0 0 6px' }}>Recuperar contraseña</h3>
            <p style={{ fontSize: 13, color: 'var(--muted)', margin: '0 0 16px' }}>
              Escribe tu usuario o correo. Se enviará una solicitud al administrador para que restablezca tu contraseña.
            </p>
            {mensajeRecuperar ? (
              <>
                <div style={{ background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', color: 'var(--ok)', borderRadius: 9, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>
                  {mensajeRecuperar}
                </div>
                <button onClick={() => setVistaRecuperar(false)}
                  style={{ width: '100%', height: 40, borderRadius: 9, border: 'none', background: 'var(--brand)', color: 'var(--on-brand)', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                  Cerrar
                </button>
              </>
            ) : (
              <form onSubmit={solicitarRecuperacion}>
                <input type="text" value={emailRecuperar} onChange={e => setEmailRecuperar(e.target.value)}
                  placeholder="nombre o correo" autoFocus
                  style={{ width: '100%', height: 40, border: '1px solid var(--line-strong)', borderRadius: 9, padding: '0 14px', fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box', marginBottom: 14 }} />
                <button type="submit" disabled={enviandoRecuperar}
                  style={{ width: '100%', height: 40, borderRadius: 9, border: 'none', background: 'var(--brand)', color: 'var(--on-brand)', fontSize: 14, fontWeight: 600, cursor: enviandoRecuperar ? 'not-allowed' : 'pointer', opacity: enviandoRecuperar ? .7 : 1 }}>
                  {enviandoRecuperar ? 'Enviando…' : 'Solicitar recuperación'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
